/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true, // set to false to use static SVG
};

const greeting = {
  username: "Ujjwal Shrestha",
  title: "Hi all, I'm Ujjwal",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of designing and building Web and Mobile applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/0B91RGXyfdwL1b0ctdHpSZEVVSE9zNDNfTk9lYjVFb0NmTXI4/view?usp=sharing&resourcekey=0-a9Czlblc_rqek5o4i1fc6w",
  displayGreeting: true, // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ujjwal-stha",
  linkedin: "https://www.linkedin.com/in/ujjwal-shrestha-0653bb175/",
  gmail: "shrestha19ujjwal@gmail.com",
  // gitlab: "https://gitlab.com/",
  facebook: "https://www.facebook.com/uijwal.shrestha",
  //medium: "https://medium.com/@davidrakosi",
  //stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  //instagram: 'https://www.instagram.com/davidrakosi/',
  twitter: "https://twitter.com/UjjwalS04770699",
  display: true, // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt",
    },
    // {
    //   skillName: "sass",
    //   fontAwesomeClassname: "fab fa-sass"
    // },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node",
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java",
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php",
    },
    {
      skillName: "angular",
      fontAwesomeClassname: "fab fa-angular",
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git",
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm",
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    // {
    //   schoolName: "Harvard University",
    //   logo: require("./assets/images/harvardLogo.png"),
    //   subHeader: "Master of Science in Computer Science",
    //   duration: "September 2017 - April 2019",
    //   desc: "Participated in the research of XXX and published 3 papers.",
    //   descBullets: [
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
    //   ]
    // },
    {
      schoolName: "Sikkim Manipal University",
      logo: require("./assets/images/SMU_Logo.jpg"),
      subHeader: "Bachelor of Science inInformation Technology",
      duration: "November 2014 - October 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Project Management, Web Security,Operating Systems, AI ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"],
    },
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "ReactJs", //Insert stack or technology you have experience in
      progressPercentage: "100%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%",
    },
    {
      Stack: "Git",
      progressPercentage: "70%",
    },
    {
      Stack: "JavaScript",
      progressPercentage: "99%",
    },
    {
      Stack: "Web Development",
      progressPercentage: "90%",
    },
  ],
  displayCodersrank: true, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Free Lancer",
      company: "Up Work",
      companylogo: require("./assets/images/upWork.png"),
      date: "May 2020 – Present",
      desc: "writing reusable, testable, and efficient code and developing and designing front end web applications.",
      descBullets: [
        "Devloping and designing front end web structure",
        "Build interactive consumer data from multiple systems",
        "Translate wireframes and PSD Designs into functional web applications",
        "Developing well-functioning databases and applications",
        "Integrating third-party APIs and software libraries into existing projects",
        "Working with other tools such as version control software and Node.js for development and deployment",
        
      ],
    },
    {
      role: "Angular/React Developer",
      company: "Syntegrate",
      companylogo: require("./assets/images/syntegrate_logo.jpg"),
      date: "Jan 2019 – March 2020",
      desc: "I develop web application as Syntegrate's App Dev Team",
      descBullets: [
        "Assist in creation of Functional Design",
        "Assist in Web Platform Development and Deployment",
        "Prepare of Administration, user and Training Manuals",
        "Perform Apllication Maintenance",
        "Maintian System Documents",
      ],
    },
    // {
    //   role: "Junior Information Security & Systems Representative",
    //   company: "Vodafone",
    //   companylogo: require("./assets/images/vodafoneLogo.png"),
    //   date: "November 2018 – July 2019",
    //   desc: "I've conducted internal audit making sure the organization is compliant with the GDPR.",
    // },
  ],
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "ujjwal-stha", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false, // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/memories.png"),
      projectName: "Memories",
      projectDesc:
        "This is Full Stack social media MERN app with redux called Memories which allows users to post interesting events that happened in their lives.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://mernmemoriesfinalujjwal.netlify.app/posts",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/inotebook-logo.jpg"),
      projectName: "iNoteBook",
      projectDesc:
        "iNotebook(MERN stack) is an web application that stores the user's notes in the cloud.",
      footerLink: [
        {
          name: "Visit Website",
          url: "",
        },
      ],
    },
    {
      image: require("./assets/images/covid-19_tracker.jpg"),
      projectName: "Covid-19 tracker",
      projectDesc:
        "Covid-19 Tracker App built using React which tracks the covid cases in all countries and shows Total cases, Recovered cases and Deaths occured of all countries and also shows live cases using graph, table and Map.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://covid-19-tracker-26c4d.web.app/",
        },
      ],
    },
    {
      image: require("./assets/images/Amazon-logo-black.jpg"),
      projectName: "Amazon Clone",
      projectDesc:
        "It is a fully working E-Commerce Amazon clone that includes user registration, login, authentication, store cart management, order management, and payment using STRIPE, among other features.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://challenge-7d665.web.app/",
        },
      ],
    },
    {
      image: require("./assets/images/disney-logo.png"),
      projectName: "Disney+ Clone",
      projectDesc:
        "A Disney+ clone built with React, Redux, Styled Components, Firebase, and is mobile responsive.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://disneyplus-clone-7104f.web.app/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/netflix-logo.jpg"),
      projectName: "Netflix-Clone",
      projectDesc:
        "Netflix Clone app built using React, Firebase and TMDB Database which is used to fetch movie data.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://netflix-clone-ed64e.web.app/",
        },
        //  you can add extra buttons here.
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "",
        },
        {
          name: "Award Letter",
          url: "",
        },
        {
          name: "Google Code-in Blog",
          url: "",
        },
      ],
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "",
        },
      ],
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "",
        },
      ],
    },
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?",
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(""),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: "",
    },
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [""],
  display: false, // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "(986) 188 8414",
  email_address: "shrestha19ujjwal@gmail.com",
};

// Twitter Section

const twitterDetails = {
  userName: "UjjwalS04770699", //Replace "twitter" with your twitter username without @
  display: false, // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
};
